export default __webpack_public_path__ + "static/media/field_right.277635bf.jpg";